import { useMemo } from "react";
import type { SellerPermission } from "@/lib/api/types";
import { useSessionQuery } from "@/shared/services/useSessionQuery";

/**
 * Returns a guard function for the seller's permissions on the active store.
 * The permissions come from the `/seller/auth/me` response and are resolved
 * server-side by joining store_members.role_ids → store_roles.permissions.
 */
export function useHasPermission(storeSlug: string) {
  const { data } = useSessionQuery({ storeSlug });
  const permissions: SellerPermission[] = data?.seller?.permissions ?? [];

  return useMemo(() => {
    const set = new Set(permissions);
    return (permission: SellerPermission): boolean => set.has(permission);
  }, [permissions]);
}
